@let isPrimaryCustomer = isPrimaryCustomer$ | async;

@if (isEditMode) {
<div class="general-info-tab-block general-info-tab-block--edit">

    <div class="general-info-tab-block-header">

        <div class="general-info-tab-block-header-title rpc-title-font">
            {{ 'GENERAL_INFO_TAB.TITLES.GENERAL' | translate }}
        </div>

    </div>

    <div class="rpc-divider rpc-divider--horizontal">
    </div>

    <general-info-form class="general-info-tab-block-body" [isPrimaryCustomer]="isPrimaryCustomer"
        [isSelfProfile]="isSelfProfile" [emails]="emails" [phones]="phones" [addresses]="addresses">
    </general-info-form>

    <div class="rpc-divider rpc-divider--horizontal">
    </div>

    <div class="general-info-tab-block-footer">

        <rpc-button [appearanceType]="'stroke'" [text]="'GENERAL_INFO_TAB.TITLES.CANCEL'" (clicked)="onCancel()">
        </rpc-button>

        <rpc-button [color]="'accent'" [appearanceType]="'flat'" [text]="'GENERAL_INFO_TAB.TITLES.SAVE'"
            [disabled]="isFormInvalid" (clicked)="onSave()">
        </rpc-button>

    </div>

</div>
} @else {
<div class="general-info-tab-block">

    <div class="general-info-tab-block-header general-info-tab-block-header--right">

        <div class="general-info-tab-block-header-title rpc-title-font">
            {{ 'GENERAL_INFO_TAB.TITLES.GENERAL' | translate }}
        </div>

        <div class="general-info-tab-block-header-right">

            <rpc-button [appearanceType]="'flat'" [color]="'accent'" [iconName]="'edit'"
                [text]="'GENERAL_INFO_TAB.TITLES.EDIT'" (clicked)="onEdit()">
            </rpc-button>

        </div>

    </div>

    <div class="rpc-divider rpc-divider--horizontal">
    </div>

    <general-info class="general-info-tab-block-body" [isPrimaryCustomer]="isPrimaryCustomer"
        [isSelfProfile]="isSelfProfile" [emails]="emails" [phones]="phones" [addresses]="addresses">
    </general-info>

</div>
}